import { Heart, Coins, Users } from 'lucide-react'
import { cn } from '@/utils/cn'
import { useTranslation } from 'react-i18next'

export type DonationFilter = 'all' | 'zakat' | 'sadaqah' | 'orphans'

interface DonationFiltersProps {
  selectedFilter: DonationFilter
  onFilterChange: (filter: DonationFilter) => void
}

export default function DonationFilters({ selectedFilter, onFilterChange }: DonationFiltersProps) {
  const { t } = useTranslation()

  const filters = [
    { id: 'all' as DonationFilter, label: t('common.filters.all', 'الكل'), icon: null },
    { id: 'zakat' as DonationFilter, label: t('categories.zakat', 'زكاة'), icon: Coins },
    { id: 'sadaqah' as DonationFilter, label: t('categories.sadaqah', 'صدقة'), icon: Heart },
    { id: 'orphans' as DonationFilter, label: t('categories.orphans', 'الأيتام'), icon: Users },
  ]

  return (
    <div className="flex flex-wrap gap-3">
      {filters.map((filter) => {
        const Icon = filter.icon
        return (
          <button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={cn(
              'flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors',
              selectedFilter === filter.id
                ? 'bg-primary-600 text-white'
                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
            )}
          >
            {Icon && <Icon className="w-4 h-4" />}
            {filter.label}
          </button>
        )
      })}
    </div>
  )
}

